const approved = require('./data/approved-listing-locations.json')

// Stable IDs keep the reviewed coordinate overlay independent of editable titles.
function applyApprovedListingLocation(listing = {}) {
  const id = String(listing._id || '').replace(/^drafts\./, '')
  const location = approved.locations[id]
  if (!location) return listing
  return {
    ...listing,
    latitude: String(location.latitude),
    longitude: String(location.longitude),
    locationReference: location,
  }
}

module.exports = { applyApprovedListingLocation }
